import api from './api';

const BILLING_SERVICE_URL = process.env.REACT_APP_FAST_FOOD_SERVICE || '';

const billingService = {
    // Obtener la configuración actual de Facturación Electrónica
    getConfig: async () => {
        const response = await api.get('/api/payments/billing/config/', { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Guardar / Actualizar la configuración
    saveConfig: async (configData) => {
        const response = await api.post('/api/payments/billing/config/', configData, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Probar conexión y autenticación con KoaDoc API
    testConnection: async (data = {}) => {
        const response = await api.post('/api/payments/billing/test-connection/', data, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Emitir manualmente la factura de una orden ante el SRI
    // invoiceFormat: 'detailed' | 'consolidated'. Sin valor, el backend usa el guardado en la orden
    emitOrderInvoice: async (orderId, invoiceFormat) => {
        const body = invoiceFormat ? { order_id: orderId, invoice_format: invoiceFormat } : { order_id: orderId };
        const response = await api.post('/api/payments/billing/emit-order/', body, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Facturar solo algunos productos de la orden
    // data: { order_id, items: [{ item_id, quantity }], amount, invoice_format, payment_method }
    emitPartialInvoice: async (data) => {
        const response = await api.post('/api/payments/billing/emit-partial/', data, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Reintentar una factura por productos que falló
    retryPartialInvoice: async (invoiceId) => {
        const response = await api.post('/api/payments/billing/retry-partial/', { invoice_id: invoiceId }, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Consultar el estado de una factura por productos en el SRI / KoaDoc
    getPartialInvoiceStatus: async (invoiceId) => {
        const response = await api.get(`/api/payments/billing/partial-status/?invoice_id=${invoiceId}`, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    },

    // Consultar estado de la factura en el SRI / KoaDoc
    getOrderInvoiceStatus: async (orderId) => {
        const response = await api.get(`/api/payments/billing/order-status/?order_id=${orderId}`, { baseURL: BILLING_SERVICE_URL });
        return response.data;
    }
};

export default billingService;
